import { render, staticRenderFns } from "./PrkDidacticMethodsContent.vue?vue&type=template&id=4bba1232&scoped=true&"
import script from "./PrkDidacticMethodsContent.vue?vue&type=script&lang=js&"
export * from "./PrkDidacticMethodsContent.vue?vue&type=script&lang=js&"
import style0 from "./PrkDidacticMethodsContent.vue?vue&type=style&index=0&id=4bba1232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba1232",
  null
  
)

export default component.exports